import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  communicationLogService,
  CommunicationLog,
  CreateCommunicationLogDto,
} from '../services/communicationLogService';
import { queryKeys } from '../config/queryKeys';

export function useCommunicationLogsByJob(jobId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.communicationLogs.byJob(jobId!),
    queryFn: () => communicationLogService.getCommunicationLogsByJob(jobId!),
    enabled: !!jobId,
  });
}

export function useCommunicationLogsByCustomer(customerId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.communicationLogs.byCustomer(customerId!),
    queryFn: () => communicationLogService.getCommunicationLogsByCustomer(customerId!),
    enabled: !!customerId,
  });
}

export function useCreateCommunicationLog() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateCommunicationLogDto) =>
      communicationLogService.createCommunicationLog(data),
    onSuccess: (newLog) => {
      // Invalidate job's communication logs
      queryClient.invalidateQueries({
        queryKey: queryKeys.communicationLogs.byJob(newLog.jobId),
      });
      // Invalidate customer's communication logs if customerId exists
      if (newLog.customerId) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.communicationLogs.byCustomer(newLog.customerId),
        });
      }
    },
  });
}

export function useDeleteCommunicationLog() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => communicationLogService.deleteCommunicationLog(id),
    onSuccess: () => {
      // Invalidate all communication logs queries since we don't know which job/customer it belonged to
      queryClient.invalidateQueries({
        queryKey: queryKeys.communicationLogs.all,
      });
    },
  });
}
